import { Button, DataSource, Label, Layout, Panel, Splitter, Textbox, Tree } from "@mcleod/components";

export abstract class AutogenLayoutMetricViewer extends Layout {
    buttonDisplayCharts: Button;
    labelMetrics: Label;
    labelProcesses: Label;
    panelCharts: Panel;
    panelMetricSelection: Panel;
    panelProcesses: Panel;
    panelSelection: Panel;
    sourceMetricAttribute: DataSource;
    sourceMetricCategory: DataSource;
    sourceMetricData: DataSource;
    splitterMetrics: Splitter;
    textboxFilterAttributes: Textbox;
    treeMetricAttributes: Tree;
    treeProcesses: Tree;
}
